import "@blueprintjs/core/lib/css/blueprint.css";
import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { I18n } from "react-redux-i18n";
import Select from "./select/Select.js";
import moment from "moment";
import "./select/chargingStation.css";
import "./select/client.css";

const overlayStyles = {
  position: "fixed",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: "rgba(0, 0, 0, 0.5)",
  zIndex: 1000,
};

const modalStyles = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "80%",
  height: "70%",
  backgroundColor: "white",
  borderRadius: "8px",
  boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)",
  padding: "20px",
};

const modalContentStyles = {
  padding: "20px",
  height: "100%", // Adjusting content height to fit inside modal
  overflow: "auto",
};

const ViewLogsModal = ({ onClose, myChargerData, setAlert }) => {
  const [listSystemLog, setListSystemLog] = useState([]);
  const [filtersList, setFiltersList] = useState([]);
  const [selectedItem, setSelectedItem] = useState(false);
  const [startDate, setStartDate] = useState("");
  const [stopDate, setStopDate] = useState("");

  const [statusValue, setStatusValue] = useState("");
  const [triggetValue, setTriggetValue] = useState("");
  const [plugValue, setPlugValue] = useState("");
  const [timeValue, setTimeValue] = useState("");

  const heading = [
    "Plug ID",
    "Direction",
    "Protocol call type",
    "Timestamp",
    "Status",
  ];

  const statusList = ["Sucesso", "Falha"];

  const timeList = [
    I18n.t("last_hour_logs"),
    I18n.t("last_two_hours_logs"),
    I18n.t("last_three_hours_logs"),
    I18n.t("last_day_logs"),
    I18n.t("last_week_logs"),
  ];

  const modalRef = useRef();

  useEffect(() => {
    if (myChargerData.selectedCharger.hwId) {
      handleGetSystemLog();
    }
  }, [
    myChargerData,
    statusValue,
    triggetValue,
    plugValue,
    startDate,
    stopDate,
  ]);

  useEffect(() => {
    changeTimezone();
  }, [timeValue]);

  const changeTimezone = () => {
    setStopDate(new Date());
    if (timeValue === I18n.t("last_hour_logs")) {
      setStartDate(new Date(new Date().setHours(new Date().getHours() - 1)));
    } else if (timeValue === I18n.t("last_two_hours_logs")) {
      setStartDate(new Date(new Date().setHours(new Date().getHours() - 2)));
    } else if (timeValue === I18n.t("last_three_hours_logs")) {
      setStartDate(new Date(new Date().setHours(new Date().getHours() - 3)));
    } else if (timeValue === I18n.t("last_day_logs")) {
      setStartDate(new Date(new Date().setDate(new Date().getDate() - 1)));
    } else if (timeValue === I18n.t("last_week_logs")) {
      setStartDate(new Date(new Date().setDate(new Date().getDate() - 7)));
    } else {
      setStartDate("");
    }
  };

  const handleGetSystemLog = () => {
    const data = {
      hwId: myChargerData.selectedCharger.hwId,
      success:
        statusValue === "Sucesso"
          ? "true"
          : statusValue === "Falha"
          ? "false"
          : null,
      type: triggetValue,
      plugId: plugValue,
      startDate: startDate,
      stopDate: stopDate,
    };

    axios
      .post("api/private/connectionstation/ocppj/logs", data, {
        headers: { "Content-Type": "application/json" },
      })
      .then((res) => {
        if (filtersList.length === 0) {
          buildFilters(res?.data?.data);
        }
        setListSystemLog(res?.data?.data);
      })
      .catch((err) => {
        if (err.response) {
          setAlert(err.response.data, "danger");
        } else {
          console.error("Erro:", err.message);
        }
      });
  };

  function buildFilters(data) {
    const context = "Function buildFilters";
    try {
      let filters = {
        success: [],
        type: [],
        plugId: [],
        trigger: [],
      };

      data.forEach((log) => {
        // Check success
        if (!filters.success.includes(log.success)) {
          filters.success.push(log.success);
        }

        // Check type
        if (!filters.type.includes(log.type)) {
          filters.type.push(log.type);
        }

        // Check plugId
        if (!filters.plugId.includes(log.plugId)) {
          filters.plugId.push(log.plugId);
        }
        // Check trigger
        if (!filters.trigger.includes(log.trigger)) {
          filters.trigger.push(log.trigger);
        }
      });
      return setFiltersList(filters);
    } catch (error) {
      console.error(`[${context}] Error `, error.message);
      return {
        success: [],
        trigger: [],
        plugId: [],
      };
    }
  }

  const handleOverlayClick = (e) => {
    if (modalRef.current && !modalRef.current.contains(e.target)) {
      onClose();
    }
  };

  return (
    <div style={overlayStyles} onClick={handleOverlayClick}>
      <div style={modalStyles} ref={modalRef}>
        <div style={modalContentStyles}>
          <div className="system-log-section">
            <div className="filters">
              <div className="filter-title">
                {I18n.t("search_title_systemLog")}
              </div>
              <div className="filter-options">
                <Select
                  value={statusValue}
                  onChange={(e) => setStatusValue(e.target.value)}
                  systemLog={statusList}
                  title={
                    statusValue.length == 0
                      ? I18n.t("systemLog_status")
                      : I18n.t("systemLog_all")
                  }
                  triggerValue={triggetValue}
                />
                <Select
                  value={triggetValue}
                  onChange={(e) => setTriggetValue(e.target.value)}
                  systemLog={filtersList.type}
                  title={
                    triggetValue.length == 0
                      ? I18n.t("systemLog_triggerMessage")
                      : I18n.t("systemLog_all")
                  }
                />

                <Select
                  value={timeValue}
                  onChange={(e) => setTimeValue(e.target.value)}
                  systemLog={timeList}
                  title={
                    timeValue.length == 0
                      ? I18n.t("systemLog_logPeriod")
                      : I18n.t("systemLog_all")
                  }
                />
                <Select
                  value={plugValue}
                  onChange={(e) => setPlugValue(e.target.value)}
                  systemLog={filtersList.plugId}
                  title={
                    plugValue.length == 0
                      ? I18n.t("systemLog_plug")
                      : I18n.t("systemLog_all")
                  }
                />
              </div>
            </div>

            <div id="table-container-system-log">
              <div className="table-head">
                {heading.map((head, index) => (
                  <div className="networks-check-title" key={index}>
                    {head}
                  </div>
                ))}
              </div>
              <div>
                {listSystemLog.length !== 0 ? (
                  listSystemLog.map((item, index) => (
                    <div
                      className={
                        index % 2
                          ? "table-body item-even"
                          : "table-body item-odd"
                      }
                      key={index}
                    >
                      <>
                        <div className="td">{item.plugId}</div>
                        <div className="td">{I18n.t(item.trigger)}</div>
                        <div className="td">{item.type}</div>
                        <div className="td">
                          {moment(item.timestamp).format("DD/MM/YYYY HH:mm:ss")}
                        </div>
                        <div className="td">
                          <button
                            className={
                              item.success ? "success-status" : "error-status"
                            }
                            style={{ cursor: "auto" }}
                            value={index}
                          >
                            {item.success
                              ? I18n.t("general_success")
                              : I18n.t("general_fail")}
                          </button>
                        </div>
                      </>
                    </div>
                  ))
                ) : (
                  <p className="no-system-log">{I18n.t("no_records")}</p>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewLogsModal;
